export const addPetClicked = () => ({
  type: 'Add Pet Clicked',
});

export const tnCClicked = () => ({
  type: 'T&C Clicked',
});

export const privacyPolicyClicked = () => ({
  type: 'Privacy policy clicked',
});
